import React from 'react';
import { McModal } from '@maersk-global/mds-react-wrapper/mc-modal';
import { McLoadingIndicator } from '@maersk-global/mds-react-wrapper/mc-loading-indicator';
import { API_URL } from '../../services/api-config'; // for potential future expansion
import { formatDateAndTime } from '../../utils/helper';


const CaseHistoryModal = ({
  open,
  onClose,
  selectedCaseNumber,
  historyData,
  historyLoading,
  setHistoryLoading,
  setUnreadModalData,
  setUnreadModalOpen,
  setEmailViewData,
  setEmailViewOpen,
  hideEmailColumns = false,
  width = '98vw',
  height = '60vh',
}) => {
  return (
    <McModal
      heading={`Case History - ${selectedCaseNumber || ''}`}
      closed={onClose}
      open={open}
      width={width}
      height={height}
    >
      <div style={{ padding: '10px', maxHeight: '60vh', overflowY: 'auto' }}>
        {historyLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
            <McLoadingIndicator appearance="primary" />
          </div>
        ) : historyData && historyData.error ? (
          <div style={{ color: 'red' }}>Error: {historyData.error}</div>
        ) : Array.isArray(historyData) && historyData.length === 0 ? (
          <div>No history available for this case.</div>
        ) : Array.isArray(historyData) ? (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ fontSize: '14px', color: '#1686BD'}}>
              <tr>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '8px' }}>Case Number</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '8px' }}>Case Status</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '8px' }}>Activity Performed</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '8px' }}>Modified Date Time</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '8px' }}>Modified By</th>
                {!hideEmailColumns && (
                  <>
                    <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '8px' }}>Emails Sent By</th>
                    <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '8px' }}>Emails Sent On</th>
                    <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '8px' }}>Details</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {historyData
                .filter((h) => h.modifiedby !== 'test_user modify later in ing db_write 36')
                .map((h, idx) => (
                <tr key={idx} style={{ borderBottom: '1px solid #f1f1f1' }}>
                  <td style={{ padding: '8px', fontSize: 'small' }}>{h.casenumber ?? ''}</td>
                  <td style={{ padding: '8px', fontSize: 'small' }}>{h.casestatus ?? ''}</td>
                  <td style={{ padding: '8px', fontSize: 'small' }}>{h.activitylog}</td>
                  <td style={{ padding: '8px', fontSize: 'small' }}>{h.datetime ? formatDateAndTime(h.datetime) : ''}</td>
                  <td style={{ padding: '8px', fontSize: 'small' }}>{h.modifiedby ?? ''}</td>
                  {!hideEmailColumns && (
                    <>
                      <td style={{ padding: '8px', fontSize: 'small' }}>{h.emailreceivedfrom ?? ''}</td>
                      <td style={{ padding: '8px', fontSize: 'small' }}>{h.emailreceivedat ? formatDateAndTime(h.emailreceivedat) : ''}</td>
                      <td style={{ padding: '8px', fontSize: 'small' }}>
                        {h.activitylog === 'Email Received' || h.activitylog === 'Missing Info Email Received' ? (
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              setHistoryLoading(true);
                              try {
                                const casenumber = h.casenumber || selectedCaseNumber;
                                if (!casenumber) {
                                  setUnreadModalData({ casenumber: null, messages: [], error: 'No case number' });
                                  setUnreadModalOpen(true);
                                  return;
                                }

                                const params = new URLSearchParams({ casenumber });

                                if (h.emailreceivedat) {
                                  const formatted = String(h.emailreceivedat).replace('T', ' ').split('.')[0];
                                  params.append('emailreceivedat', formatted);
                                  console.log('emailreceivedat:  ', h.emailreceivedat);
                                  console.log('Formatted emailreceivedat:  ', formatted);
                                }

                                if (h.activitylog) params.append('activitylog', String(h.activitylog));

                                const url = `${API_URL}/get_case_messages_by_activity?${params.toString()}`;
                                const resp = await fetch(url);
                                if (!resp.ok) {
                                  const text = await resp.text().catch(() => resp.statusText || 'error');
                                  setUnreadModalData({ casenumber, messages: [], error: `Failed to fetch messages: ${resp.status} ${text}` });
                                  setUnreadModalOpen(true);
                                  return;
                                }

                                const json = await resp.json();
                                const allMessages = Array.isArray(json.messages) ? json.messages : (Array.isArray(json) ? json : (json.messages || []));
                                setEmailViewData({ casenumber, messages: allMessages, error: json.error });
                                setEmailViewOpen(true);
                              } catch (err) {
                                setUnreadModalData({ casenumber: h.casenumber, messages: [], error: err.message || String(err) });
                                setUnreadModalOpen(true);
                              } finally {
                                setHistoryLoading(false);
                              }
                            }}
                          >
                            View Email
                          </a>
                        ) : (
                          <span />
                        )}
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div>Unable to display history.</div>
        )}
      </div>
    </McModal>
  );
};

export default CaseHistoryModal;
